<template>
    <div ref="mapContainer" style="height: 100%; width: 100%"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import MapTransformTool from '../../util/transform.js';

export default {
    components: {},
    props: {
        markerPosition: {
            type: Array,
            default() {
                return [];
            },
        },
        markerList: {
            type: Array,
            default() {
                return [];
            },
        },
        evenType: {
            type: String,
            default() {
                return '';
            },
        },
        // 是否开启拾取位置
        enablePick: {
            type: Boolean,
            default: true,
        },
        // 坐标系类型
        coordType: {
            type: String,
            default() {
                return 'gcj02';
            },
        },
    },
    data() {
        return {
            position: this.markerPosition || [],
            address: '',
            inputSearchVal: '',
            searchResult: [],
            marker: '',
        };
    },
    computed: {
        positionText() {
            let text = '';
            let position = this.position || [];
            // if (this.coordType === 'wgs84') {
            //     let lng = position[0];
            //     let lat = position[1];
            //     if (lng && lat) {
            //         lng = Number(lng);
            //         lat = Number(lat);
            //         position = MapTransformTool.gcj02towgs84(lng, lat);
            //     }
            // }
            text = position.join();
            return text;
        },
    },
    methods: {
        initMap() {
            let self = this;
            AMapLoader.load({
                key: '077cbbc870989dc1b3e2d6e43b8f8788', // 申请好的Web端开发者Key，首次调用 load 时必填
                version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: ['AMap.PlaceSearch', 'AMap.AutoComplete', 'AMap.Geocoder'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            })
                .then((AMap) => {
                    let satelliteLayer = new AMap.TileLayer.Satellite();
                    console.log('this.markerPosition', this.markerPosition);
                    self.map = new AMap.Map(self.$refs.mapContainer, {
                        // 设置地图容器id
                        zoom: 19, // this.markerPosition[0] !== '' ? 19 : 19, // 初始化地图级别
                        center: this.markerPosition[0] !== '' ? this.markerPosition : [113.14958, 23.035191], // 初始化地图中心点位置
                    });
                    // 批量添加图层
                    self.map.add([satelliteLayer]);
                    // 网格图层
                    // let wms = new AMap.TileLayer.WMS({
                    //     url: '/geoserver/gc.layer/wms?service=WMS&version=1.1.0&request=GetMap&layers=gc.layer%3A%E5%8D%97%E6%B5%B7%E5%8C%BA%E6%A1%82%E5%9F%8E%E8%A1%97%E9%81%93%E7%BD%91%E6%A0%BC&bbox=113.10641180009465%2C22.971716904388245%2C113.26262540038051%2C23.07951473898294&width=768&height=529&srs=EPSG%3A4326&styles=&format=application/openlayers',
                    //     blend: true,
                    //     tileSize: 256,
                    //     params: {
                    //         LAYERS: 'map:shanghai',
                    //         VERSION: '1.1.0',
                    //     },
                    // });

                    // wms.setMap(self.map);
                    let markers = [];
                    // 设置一个图标对象
                    let icon = {
                        type: 'image', // 图标类型，现阶段只支持 image 类型
                        image: require('./img/point.png'), // 图片 url 'https://a.amap.com/jsapi_demos/static/demo-center/marker/express2.png',
                        size: [24, 24], // 图片尺寸
                        anchor: 'center', // 图片相对 position 的锚点，默认为 bottom-center
                    };
                    // // 生成infoWindow对象,infoWindow在data内命名了
                    // this.infoWindow = new AMap.InfoWindow({
                    //     offset: new AMap.Pixel(0, -30),
                    // });
                    // 初始化 labelMarker
                    self.markerList.forEach((item, index) => {
                        let obj = {
                            name: item.name,
                            position: [item.longitude, item.latitude],
                            zooms: [10, 20],
                            opacity: 1,
                            zIndex: 4,
                            icon,
                        };
                        // let marker = new AMap.Marker({
                        //     icon, // 这里是地图的icon,需要自己配置
                        //     name: item.name,
                        //     position: [item.longitude, item.latitude],
                        //     zooms: [10, 20],
                        //     opacity: 1,
                        //     zIndex: 4,
                        // });
                        // // 构造点击marker展示的内容-绑定每个点击对象,注意类名为`detailBtn`
                        // const markerContent = `
                        //     <div class="p-marker-info">
                        //         <div class="info-item">
                        //         <label>库存名称:</label>
                        //         <span>${item.name}</span>
                        //         <div class="info-item">
                        //         <label class="detailBtn" comId=${item.id}>查看详情</label>
                        //         </div>
                        //     </div>
                        //     `;
                        // marker.infoWindow = markerContent;// 把infoWindow绑定给marker
                        // // 绑定点击事件，在点击的时候给infowindow绑定点击事件，因为只有点击之后才会生成infoWindow这个dom
                        // marker.on('click', (e) => {
                        //     this.showInfoWindow(marker);
                        // });
                        let labelMarker = new AMap.LabelMarker(obj);
                        labelMarker.on('click', (e) => {
                            this.showInfoWindow(obj, item);
                        });
                        markers.push(labelMarker);
                    });
                    // 将 marker 添加到图层
                    self.map.add(markers);
                    // if (self.enablePick) {
                    //     self.map.on('click', (e) => {
                    //         let lng = e.lnglat.getLng();
                    //         let lat = e.lnglat.getLat();
                    //         let position = [lng, lat];
                    //         self.position = position;
                    //         if (!self.marker) {
                    //             const marker = new AMap.Marker({
                    //                 position,
                    //                 zIndex: 1000,
                    //             });
                    //             this.marker = marker;
                    //             // 将创建的点标记添加到已有的地图实例：
                    //             self.map.add(marker);
                    //         } else {
                    //             self.marker.setPosition(e.lnglat);
                    //         }
                    //         self.getAddress(position);
                    //     });
                    // }
                    self.initMapSearch();
                    self.initMarker();
                })
                .catch((e) => {
                    // console.log(e);
                });
        },
        initMapSearch() {
            /* eslint-disable */
            if (!this.map) return;
            let placeSearch = new AMap.PlaceSearch({
                city: '佛山市',
                map: this.map,
            });
            this.placeSearch = placeSearch;
        },

        // 绘制弹窗
        showInfoWindow(data, obj) {
            window.associatedEvents = this.associatedEvents(obj);
            let lnglat = data.position;

            let infoWindow;
            let info = [];
            // 组成一个要显示的dom，class可以增加对应的css，不过要加scoped可能不起作用，加scoped的话，less或者sass 可以用deep
            info.push(`<div class='map-mask'>`);
            info.push(`<div class='map-title'><div class='map-type'>${obj.eventTypeName} </div></div>`);
            info.push(`<img class='map-img' src='${obj.thumbnail}' />`);
            info.push('<ul class="">');
            info.push(`<li><span>发现时间：</span>${obj.happenTime}</li>`);
            info.push(`<li><span>名称：</span>${obj.name}</li>`);
            info.push(`<li> <span>地址：</span>${obj.address}</li>`);
            info.push(
                `<li><buttom class="map-btn" onclick="associatedEvents('${obj}')">关联事件</bottom></li>`,
            );
            info.push('</ul>');
            info.push(`</div>`);
            // 创建浮窗
            infoWindow = new AMap.InfoWindow({
                // isCustom: true,
                // offset: new AMap.Pixel(26, -5), // 偏移量
                content: info.join(''), // 使用默认信息窗体框样式，显示信息内容
            });
            infoWindow.open(this.map, lnglat); // 打开弹窗
        },

        associatedEvents(obj) {
            this.$emit('associatedEvents', obj);
        },
        handleSearchClick(data) {
            console.log(data);
            if (typeof data === 'string') {
                let location = data.split(',');
                console.log(location);
                this.position = location;
                this.initMarker();
            }
        },
        initMarker() {
            let self = this;
            let position = self.position;
            if (!position[0] || !position[1]) {
                position = [];
                return;
            }
            if (!this.map) return;
            if (!self.marker) {
                const marker = new AMap.Marker({
                    position,
                    zIndex: 1000,
                });
                this.marker = marker;
                // 将创建的点标记添加到已有的地图实例：
                self.map.add(marker);
            } else {
                self.marker.setPosition(position);
            }
            this.map.setCenter(position);
        },
        /**
         * 逆地理编码,根据经纬度获取地址
         * @param lnglat  array  [lng,lat]
         * */
        getAddress(lnglat) {
            let self = this;
            var geocoder = new AMap.Geocoder({
                city: '全国', // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            });

            if (Array.isArray(lnglat) && lnglat.length === 2) {
                geocoder.getAddress(lnglat, function (status, result) {
                    if (status === 'complete' && result.info === 'OK') {
                        // result为对应的地理位置详细信息
                        console.log(result);
                        var address = result.regeocode.formattedAddress;
                        self.address = address;
                    }
                });
            }
        },

        initPosition() {
            if (this.coordType === 'wgs84') {
                let position = this.markerPosition || [];
                let lng = position[0];
                let lat = position[1];
                if (lng && lat) {
                    lng = Number(lng);
                    lat = Number(lat);
                    let po = MapTransformTool.wgs84togcj02(lng, lat);
                    this.position = po || [];
                }
            }
        },
    },
    created() {
        this.initPosition();
    },
    mounted() {
        // DOM初始化完成进行地图初始化
        this.initMap();
    },
    watch: {
        markerPosition(val) {
            this.position = val || [];
            this.initPosition();
        },
    },
};
</script>

<style lang="scss">
.map-mask {
    width: 250px;
    height: 330px;
    background: white;
    padding: 0 10px 10px 10px;
    .map-title {
        margin-top: -5px;
        margin-bottom: 5px;
        .map-type {
            font-weight: 600;
            font-size: 16px;
        }
    }
    .map-img {
        width: 250px;
    }
    li {
        height: 30px;
        line-height: 30px;
        width: 250px;
        // border: 1px red solid;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        span {
            display: inline-block;
            color: rgba(29, 33, 45, 0.6);
        }
        .map-btn {
            display: block;
            width: 248px;
            height: 28px;
            line-height: 28px;
            background: rgba(46, 125, 248, 0.15);
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            text-align: center;
            color: #2e7df8;
            border: 1px solid rgba(46, 125, 248, 0.15);
        }
    }
}
.amap-sug-result {
    z-index: 99999 !important;
}
.el-message-box {
    height: 170px;
    background: white;
    box-shadow: inset 0px 0px 0px 0px #49f0fd;
    border-radius: 6px 6px;
    opacity: 1;
    border: 0px solid #49f0fd;
    .el-message-box__title {
        color: black;
        font-weight: 600;
        .el-message-box__close {
            color: black !important;
        }
    }
    .el-message-box__message {
        font-size: 14px;
    }
    .el-message-box__content {
        display: flex;
        justify-content: center;
        color: black;
        font-size: 16px;
    }

    .el-message-box__headerbtn .el-message-box__close {
        color: black !important;
    }

    .el-message-box__btns {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;

        button {
            width: 88px;
            height: 30px;
            border-radius: 2px;
            opacity: 1;
            margin: 0 8px;
            color: #303133;
            &:nth-of-type(1) {
                background: #fff;
                border: 1px solid #dcdfe6;
                color: #303133;
            }
            &.el-button--primary {
                background: #409eff;
                color: #fff;
            }
        }
    }
}
</style>
